import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useMutation } from '@apollo/client/react'

import Button from 'js/components/Button'
import Errors from 'js/components/Errors'
import Flexer from 'js/components/Flexer/Flexer'
import Text from 'js/components/Text/Text'

import { CONFIRM_ATTEND_EVENT as CONFIRM_UNATTEND_EVENT } from './ConfirmAttend.mutations'

const ConfirmUnattend = ({ entity, email, code, onClose }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const { guid, title, url } = entity

    const [confirmUnattendEvent, { error, loading }] = useMutation(
        CONFIRM_UNATTEND_EVENT,
    )

    const onSubmit = async () => {
        await confirmUnattendEvent({
            variables: { input: { guid, code, email, delete: true } },
            refetchQueries: ['EventItem'],
        })
            .then(() => {
                onClose()
                navigate(url, { replace: true })
            })
            .catch((errors) => {
                console.error(errors)
            })
    }

    return (
        <>
            <Text size="small" as="p">
                {t('entity-event.exit-attendees-email-confirm', {
                    title,
                    email,
                })}
            </Text>
            <Errors errors={error} />
            <Flexer mt>
                <Button variant="tertiary" size="normal" onClick={onClose}>
                    {t('action.no-cancel')}
                </Button>
                <Button size="normal" onClick={onSubmit} loading={loading}>
                    {t('action.yes-confirm')}
                </Button>
            </Flexer>
        </>
    )
}

export default ConfirmUnattend
